<template>
  <div class="d-overflow" @scroll.passive="handleScroll" ref="scrollContainer">
    <slot></slot>
  </div>
  <OverflowHolder v-if="positions.Top" v-show="scrollData.top_visible" position="Top" @scroll="Scroll"></OverflowHolder>
  <OverflowHolder v-if="positions.Right" v-show="scrollData.right_visible" position="Right" @scroll="Scroll">
  </OverflowHolder>
  <OverflowHolder v-if="positions.Bottom" v-show="scrollData.bottom_visible" position="Bottom" @scroll="Scroll">
  </OverflowHolder>
  <OverflowHolder v-if="positions.Left" v-show="scrollData.left_visible" position="Left" @scroll="Scroll">
  </OverflowHolder>
</template>

<script setup>

import { ref, computed, defineProps, watch, nextTick, useSlots, onMounted, defineExpose } from 'vue'
import OverflowHolder from './OverflowHolder.vue';

const slots = useSlots(); // Access slot content


const props = defineProps({
  OffsetX: { type: Number, default : 30 },
  OffsetY: { type: Number, default : 30 },
  MinScroll: { type: Number, default : 2 },
  ScrollStep: { type: Number, default : 170 },
  position: { type: String, required: true }
})

const scrollData = ref({
  scrollWidth: 0,
  scrollHeight: 0,
  objectWidth: 0,
  objectHeight: 0,
  currLeft: 0,
  currTop: 0,
  maxLeft: 0,
  maxTop: 0,
  left_visible: false,
  right_visible: false,
  top_visible: false,
  bottom_visible: false
});


const scrollContainer = ref("scrollContainer");

const positions = computed(() => {  
    var positions = {};
    var str = props.position;
    //look for "TOP"
    var patt = /Top/gi;
    positions.Top = patt.test(str);

    patt = /Bottom/gi;
    positions.Bottom = patt.test(str);

    patt = /Left/gi;
    positions.Left = patt.test(str);

    patt = /Right/gi;
    positions.Right = patt.test(str);

    patt = /All/gi;
    if (patt.test(str))
    {
        positions.Top = true;
        positions.Right = true;
        positions.Bottom = true;
        positions.Left = true;
    }

    return positions;
});

const handleScroll = () => {
  const container = scrollContainer.value;
  if (!container) return;

  // Update scroll data
  scrollData.value.scrollWidth = container.scrollWidth;
  scrollData.value.scrollHeight = container.scrollHeight;
  scrollData.value.objectWidth = container.clientWidth;
  scrollData.value.objectHeight = container.clientHeight;

  scrollData.value.currLeft = container.scrollLeft;
  scrollData.value.currTop = container.scrollTop;

  scrollData.value.maxLeft = scrollData.value.scrollWidth - scrollData.value.objectWidth;
  scrollData.value.maxTop = scrollData.value.scrollHeight - scrollData.value.objectHeight;

  // Visibility logic
  const minScroll = props.MinScroll;
  const offsetX = props.OffsetX;
  const offsetY = props.OffsetY;

  // Update scroll visibility
  scrollData.value.top_visible = 
    scrollData.value.scrollHeight > scrollData.value.objectHeight &&
    (scrollData.value.scrollHeight / scrollData.value.objectHeight * 100 - 100) > minScroll &&
    scrollData.value.currTop > 0 + offsetY;

  scrollData.value.right_visible = 
    scrollData.value.scrollWidth > scrollData.value.objectWidth &&
    (scrollData.value.scrollWidth / scrollData.value.objectWidth * 100 - 100) > minScroll &&
    scrollData.value.currLeft < scrollData.value.maxLeft - offsetX;

  scrollData.value.bottom_visible = 
    scrollData.value.scrollHeight > scrollData.value.objectHeight &&
    (scrollData.value.scrollHeight / scrollData.value.objectHeight * 100 - 100) > minScroll &&
    scrollData.value.currTop < scrollData.value.maxTop - offsetY;

  scrollData.value.left_visible = 
    scrollData.value.scrollWidth > scrollData.value.objectWidth &&
    (scrollData.value.scrollWidth / scrollData.value.objectWidth * 100 - 100) > minScroll &&
    scrollData.value.currLeft > 0 + offsetX;
};

// Function to be called externally
const SetScroll = () => {
  nextTick(() => {
    handleScroll();
  });
};


const Scroll = (pos) => {  

  if (!scrollContainer.value) return;

  if (pos === "top") {
    scrollContainer.value.scrollTo({ top: scrollData.value.currTop - props.ScrollStep, behavior: "smooth" });
  } 
  else if (pos === "right") {
    scrollContainer.value.scrollTo({ left: scrollData.value.currLeft + props.ScrollStep, behavior: "smooth" });
  } 
  else if (pos === "bottom") {
    scrollContainer.value.scrollTo({ top: scrollData.value.currTop + props.ScrollStep, behavior: "smooth" });
  } 
  else if (pos === "left") {
    scrollContainer.value.scrollTo({ left: scrollData.value.currLeft - props.ScrollStep, behavior: "smooth" });
  }
}

// Expose SetScroll function
defineExpose({ SetScroll });

// Watch for slot content changes
watch(
  () => slots.default?.(),
  async () => {
    await nextTick(); // Wait for DOM update
    handleScroll(); // Recalculate scroll data
  },
  { deep: true }
);

// Run handleScroll on mount
onMounted(() => {
  handleScroll();
});

</script>

